import { ExtensionSlot } from 'piral-core';
import React from 'react';
import borderlayout from '../layouts/borderlayout';
import verticallayout from '../layouts/verticallayout';
import horizontallayout from '../layouts/horizontallayout';
import sidebarlayout from '../layouts/sidebarlayout';
import gridlayout from '../layouts/gridlayout';
import tabslayout from '../layouts/tabslayout';

const createPage = ({ pageKey, layoutType = '', components = [] }: { pageKey: string, layoutType: string, components: object[] }) => {
  const PageComponent = (props: unknown) => {
    switch (layoutType) {
      case 'single':
        return (
          <div style={{ height: '100vh' }}>
            <ExtensionSlot name={`${pageKey}-default`} params={props} />
          </div>
        );
      case 'wizard':
        return (<div>
          <ExtensionSlot name={`${pageKey}-stepper`} params={props} />
          <ExtensionSlot name={`${pageKey}-content`} params={props} />
        </div>)
      case 'chat':
        return (<div style={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}>
          <div style={{
            flex: 1,
            overflowY: 'auto',
          }}>
            <ExtensionSlot name={`${pageKey}-content`} params={props} /></div>
          <ExtensionSlot name={`${pageKey}-input`} params={props} />
        </div>)
      case 'hbox':
        return (
          <div style={{
            display: 'flex',
            flexDirection: 'row',
          }}>
            {components.map((_component, index) => (
              <ExtensionSlot key={index} name={`${pageKey}-hbox-${index + 1}`} params={props} />
            ))}
          </div>
        )
      case 'vbox':
        return (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
          }}>
            {components.map((_component, index) => (
              <ExtensionSlot key={index} name={`${pageKey}-vbox-${index + 1}`} params={props} />
            ))}
          </div>
        )
      case 'compare':
        return (<div style={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}>
          <div style={{
            flex: 1,
            overflowY: 'auto',
          }}>
            <ExtensionSlot name={`${pageKey}-content`} params={props} /></div>
          <ExtensionSlot name={`${pageKey}-input-1`} params={props} /><br />
          <ExtensionSlot name={`${pageKey}-input-2`} params={props} />
        </div>)
      case 'border':
        return React.createElement(borderlayout.Layout, { ...(props as object), pageKey });
      case 'vertical':
        return React.createElement(verticallayout.Layout, { ...(props as object), pageKey });
      case 'horizontal':
        return React.createElement(horizontallayout.Layout, { ...(props as object), pageKey });
      case 'sidebar':
        return React.createElement(sidebarlayout.Layout, { ...(props as object), pageKey });
      case 'grid':
        return React.createElement(gridlayout.Layout, { ...(props as object), pageKey });
      case 'tabs':
        return React.createElement(tabslayout.Layout, { ...(props as object), pageKey, components });
      default:
        return (<div>Layout type {layoutType} not supported</div>)
    }
  };

  PageComponent.displayName = 'PageComponent';
  return PageComponent;
}

export default {
  createPage,
}
